function o(n, r) {
  const t = {};
  for (const e of r)
    e in n && (t[e] = n[e]);
  return t;
}
function i(n, r) {
  const t = { ...n };
  for (const e of r)
    delete t[e];
  return t;
}
function f(n) {
  return Object.fromEntries(Object.entries(n).filter(([r, t]) => t !== void 0));
}
export {
  i as omit,
  o as pick,
  f as stripUndefined
};
//# sourceMappingURL=index.js.map
